var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CenteredContent",
    { class: _vm.$style.desktopMain },
    [
      _c("Logo", { class: _vm.$style.homeLogo }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-layout",
            {
              attrs: { row: "", "justify-space-around": "", "align-center": "" }
            },
            [
              _c(
                "BaseButton",
                {
                  attrs: { "button-style": "Round" },
                  on: { click: _vm.inStoreHandler }
                },
                [
                  _c("svg", {
                    directives: [{ name: "svg", rawName: "v-svg" }],
                    class: _vm.$style.outIcon,
                    attrs: { symbol: "out-icon" }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Carry out")])
                ]
              ),
              _vm._v(" "),
              _c(
                "BaseButton",
                {
                  attrs: { "button-style": "Round" },
                  on: { click: _vm.curbsideHandler }
                },
                [
                  _c("svg", {
                    directives: [{ name: "svg", rawName: "v-svg" }],
                    class: _vm.$style.curbsideIcon,
                    attrs: { symbol: "curbside-icon" }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Curbside")])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopOptions.vue?vue&type=template&id=eabdc3b8&
// module id = null
// module chunks = 